import styled from "styled-components"

const OptionInput = styled.input``

export default OptionInput